import { useContext, useEffect } from "react";
import { formatDate, formattedPrice } from "../../../../../../../../shared/utils";
import { MasterContext } from "../../../../../../../../shared/contexts";


export const useTableConfigurationData = () => {

  const { branchList, getBranchsList } = useContext(MasterContext);
  
  useEffect(() => {
    if(!branchList?.length) getBranchsList();
  }, [branchList]);

  const getBranchName = (branchId:string) => {
    const branch = branchList?.find((b) => b.value === branchId);
    return branch ? branch.label : branchId;
  };

  const renderBranchColumn = (branchId:string) => getBranchName(branchId);

  const columns = [
    {
      title: 'Rama',
      dataIndex: 'branchQuota',
      width: '12%',
      key: 'branch',
      render: renderBranchColumn,
    },
    {
      title: 'Póliza',
      dataIndex: 'policyQuota',
      width: '12%',
      key: 'policy',
    },
    {
      title: 'Endoso',
      dataIndex: 'endorsementQuota',
      width: '12%',
      key: 'endorsement',
    },
    {
      title: 'Cuota',
      dataIndex: 'quotaQuota',
      width: '12%',
      key: 'quota',
    },
    {
      title: 'Subcuota',
      dataIndex: 'subQuotaQuota',
      width: '12%',
      key: 'subQuota',
    },
    {
      title: 'Vencimiento',
      dataIndex: 'dueQuota',
      width: '12%',
      key: 'due',
      render: (amount: string) =>  <span> {`${formatDate(amount)}`} </span>
    },
    {
      title: 'Asegurado',
      dataIndex: 'insuredQuota',
      width: '12%',
      key: 'insured',
    },
    {
      title: 'Subtotal premio',
      dataIndex: 'subtotalQuota',
      width: '12%',
      key: 'subtotal',
      render: (amount: string) =>  <span> {`$ ${formattedPrice(amount)}`} </span>
    },
  ];

  return { columns };
};